import { ReactNode } from 'react'

import { useGetTimePast } from '~/shared/hooks/useGetTimePast'

export default function NotificationWrapper({
  parentClassNames,
  createdAt,
  children,
}: {
  parentClassNames: string
  createdAt: string
  children: ReactNode
}): React.ReactElement {
  const time = useGetTimePast(createdAt)
  return (
    <div className="relative flex w-full">
      <div className={parentClassNames}>
        {children}
        <span className="px-5 text-xs text-purple-light-top font-semibold">{time}</span>
      </div>
    </div>
  )
}
